import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodeUpdatedSubscription = gql`
  subscription surfaceNodeUpdated($surface: ID!, $user: ID!) {
    surfaceNodeUpdated(surface: $surface, user: $user) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;
